import { render, staticRenderFns } from "./circular.vue?vue&type=template&id=20049c53&scoped=true"
import script from "./circular.vue?vue&type=script&lang=js"
export * from "./circular.vue?vue&type=script&lang=js"
import style0 from "./circular.vue?vue&type=style&index=0&id=20049c53&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20049c53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20049c53')) {
      api.createRecord('20049c53', component.options)
    } else {
      api.reload('20049c53', component.options)
    }
    module.hot.accept("./circular.vue?vue&type=template&id=20049c53&scoped=true", function () {
      api.rerender('20049c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/lottery/components/circular.vue"
export default component.exports